

/// <reference path="BusinessLog.ts" />

// Generated class ReactivationReasonLog_ManagedObject

class ReactivationReasonLog_ManagedObject extends BusinessLog
{

    // Property: reactivationDate
    set reactivationDate(value:Date) {
        this.setValueForKey(value, 'reactivationDate');
    }
    get reactivationDate():Date {
        return this.valueForKey('reactivationDate');
    }
    set reactivationDatePrimitiveValue(value:Date) {
        this.setPrimitiveValueForKey(value, 'reactivationDate');
    }
    get reactivationDatePrimitiveValue():Date {
        return this.primitiveValueForKey('reactivationDate');
    }
}
